export default "__VITE_ASSET__4354d61f__"